import localStorageUtils from "utils/localStorageUtils";
const absPathReg = /\/\/\w+\./;
const apiEnv = process.env.API_ENV;
function domain(env) {
  if (env === "qa") {
    return "//cms.qa.megogo.net/";
  }

  if (env === "rc") {
    return "//cms.rc.megogo.net/";
  }

  if (env === "production") {
    return "//megogo.net/";
  }

  return "";
}

export default link => {
  let result;
  if (!absPathReg.test(link)) {
    const lang = localStorageUtils.getItem("lang");
    result = link
      ? `${domain(apiEnv)}${lang}/${link}`
      : `${domain(apiEnv)}${lang}`;
  } else {
    result = link;
  }
  return result;
};
